import React from "react";
import ResellerLayout from "@/shared/components/reseller/ResellerLayout";
import Notifications from "@/shared/pages/Notifications";

const RESELLER_NOTIFICATION_TYPES = ["DEPOSIT", "WITHDRAWAL", "SYSTEM"];

export default function ResellerNotifications() {
  return (
    <ResellerLayout currentPage="ResellerNotifications">
      <Notifications
        allowedTypes={RESELLER_NOTIFICATION_TYPES}
        pageDescription="View your reseller, merchant deposit, withdrawal, and system notifications"
      />
    </ResellerLayout>
  );
}
